import { all, call, put, take, takeEvery } from "@redux-saga/core/effects";
import { AnyAction } from "redux";
import { setLoading } from "../../layouts/main-layout/MainLayout.reducer";
import { QuestionnaireStartDTO } from "../../../common/types/common.dto.types";
import {
  GETQUESTIONNAIRSTARTDROPDOWNS,
  STARTQUESTIONNAIRE,
  STARTQUESTIONNAIREONWARNINGPOPUPCLOSED,
  startQuestionnaireOnWarningPopupClosed,
} from "./QuestionnaireStartPage.action";
import {
  getQuestionnaireStartDetails,
  startQuestionnaire,
} from "./QuestionnaireStartPage.api";
import {
  changePageMode,
  navigateNext,
  setDropdownList,
  setNavigateToInspectionStandards,
  setPageModeRedirectMode,
  setQuestionnaireAlreadyStarted,
  setReadOnlyMode,
  setStartQuestionnaire,
} from "./QuestionnaireStartPage.reducer";
import { ActionResponseType } from "../../../common/types/common.types";
import {
  EnumInspectionQuestionState,
  EnumInspectionStandardStatus,
  EnumPageMode,
} from "../../../common/enums/common.enums";
import { openPopup } from "../../../components/Popups/Popup.reducer";
import { EnumPopupType } from "../../../components/Popups/Popup.enum";
import { PopupProps } from "../../../components/Popups/PopupProps.types";
import { channel } from "redux-saga";
import { RedirectObject } from "../../../common/types/common.page.type";

// Channel for starting questionnaire from callback function
// const startQuestionnaireChannel = channel();
// export function* startQuestionnaireChannelWatcher() {
//   while (true) {
//     const action = yield take(startQuestionnaireChannel);
//     yield put(action);
//   }
// }

/**
 * A custom Redux Saga channel used for navigation-related actions.
 */
const navigationChannel = channel();

/**
 * Watches the custom navigation channel and dispatches any actions received.
 */
export function* navigationChannelWatcher() {
  while (true) {
    const action = yield take(navigationChannel);
    yield put(action);
  }
}

const getDropDownListWatcher = function* (): any {
  yield takeEvery(
    GETQUESTIONNAIRSTARTDROPDOWNS,
    function* (action: AnyAction): any {
      // set page loading
      yield put(setLoading(true));

      const questionnaireStartDTO: QuestionnaireStartDTO = action.payload;

      // console.log(questionnaireStartDTO);
      const result: QuestionnaireStartDTO = yield call(() =>
        getQuestionnaireStartDetails(questionnaireStartDTO)
      );

      if (result == null && !result) {
      } else {
        yield put(setDropdownList(result));
      }
      yield put(setLoading(false));
    }
  );
};

// watcher for Start Questionnaire
const startQuestionnaireWatcher = function* (): any {
  yield takeEvery(STARTQUESTIONNAIRE, function* (action: AnyAction): any {
    yield put(setLoading(true));

    let questionnaireStart: QuestionnaireStartDTO = action.payload;

    // get data from backend
    try {
      const latestState: QuestionnaireStartDTO = yield call(() =>
        getQuestionnaireStartDetails(questionnaireStart)
      );
      if (latestState == null && !latestState) {
      } else {
        yield put(setDropdownList(latestState));
      }
      if (
        latestState.InspectionStandard.InspectionStandardStatusId ===
          EnumInspectionStandardStatus.Intial ||
        latestState.InspectionStandard.InspectionStandardStatusId ===
          EnumInspectionStandardStatus.Inprogress ||
        latestState.InspectionStandard.InspectionStandardStatusId ===
          EnumInspectionStandardStatus.Paused
      ) {
        let result: ActionResponseType = yield call(() =>
          startQuestionnaire(questionnaireStart)
        );

        if (result.IsSuccess) {
          if (result.Data.ErrorStatus > 0) {
            yield put(
              openPopup({
                Open: true,
                BodyText: result.InfoMessage,
                HeaderText: "Warning",
                PopupType: EnumPopupType.WarningPopup,
                OkBtnClick() {
                  if (
                    result.Data.ErrorStatus ===
                    EnumInspectionQuestionState.InspectionRemoved
                  ) {
                    let redirectObject = {
                      NavigateURl: "/siteInspections",
                    } as RedirectObject;

                    navigationChannel.put(
                      setPageModeRedirectMode(redirectObject)
                    );
                  }
                },
              } as PopupProps)
            );
          } else {
            questionnaireStart = result.Data;

            yield put(setStartQuestionnaire(questionnaireStart));

            // change page mode (change disable and button show hide)
            yield put(changePageMode(EnumPageMode.ViewMode));

            yield put(setReadOnlyMode(true));

            yield put(navigateNext());
          }
        } else {
          yield put(
            openPopup({
              Open: true,
              BodyText: result.ErrorMessage
                ? result.ErrorMessage
                : "Questionnaire Start not saved successfully",
              HeaderText: "Error",
              PopupType: EnumPopupType.ErrorPopup,
            } as PopupProps)
          );
        }
      } else if (
        latestState.InspectionStandard.InspectionStandardStatusId ===
        EnumInspectionStandardStatus.StartedOffline
      ) {
        yield put(
          setNavigateToInspectionStandards({
            navigateToInspectionStadnards: true,
            tempMessage:
              latestState.InspectionStandard?.AlreadyStartedMessage ?? "",
          })
        );
      } else {
        yield put(setQuestionnaireAlreadyStarted(true));
      }
    } catch (error) {
      yield put(
        openPopup({
          Open: true,
          BodyText: "An error occurred saving Questionnaire Start",
          HeaderText: "Error",
          PopupType: EnumPopupType.ErrorPopup,
        } as PopupProps)
      );
    }

    // set page loading off
    yield put(setLoading(false));
  });
};

// watcher for Start Questionnaire
// const startQuestionnaireOnWarningPopupClosedWatcher = function* (): any {
//   yield takeEvery(
//     STARTQUESTIONNAIREONWARNINGPOPUPCLOSED,
//     function* (action: AnyAction): any {
//       yield put(setLoading(true));

//       let questionnaireStart: QuestionnaireStartDTO = action.payload;

//       // get data from backend
//       try {
//         let result: ActionResponseType = yield call(() =>
//           startQuestionnaire(questionnaireStart)
//         );

//         if (result.IsSuccess) {
//           questionnaireStart = result.Data;

//           yield put(setStartQuestionnaire(questionnaireStart));

//           // change page mode (change disable and button show hide)
//           yield put(changePageMode(EnumPageMode.ViewMode));

//           yield put(setReadOnlyMode(true));

//           yield put(navigateNext());
//         } else {
//           yield put(
//             openPopup({
//               Open: true,
//               BodyText: result.ErrorMessage
//                 ? result.ErrorMessage
//                 : "Questionnaire Start not saved successfully",
//               HeaderText: "Error",
//               PopupType: EnumPopupType.ErrorPopup,
//             } as PopupProps)
//           );
//         }
//       } catch (error) {
//         yield put(
//           openPopup({
//             Open: true,
//             BodyText: "An error occurred saving Questionnaire Start",
//             HeaderText: "Error",
//             PopupType: EnumPopupType.ErrorPopup,
//           } as PopupProps)
//         );
//       }

//       // set page loading off
//       yield put(setLoading(false));
//     }
//   );
// };

const questionnaireStartSaga = function* () {
  yield all([
    startQuestionnaireWatcher(),
    getDropDownListWatcher(),
    navigationChannelWatcher(),
    //startQuestionnaireOnWarningPopupClosedWatcher(),
    //startQuestionnaireChannelWatcher(),
  ]);
};

export default questionnaireStartSaga;
